<template>
  <v-container fluid>
    <v-row dense>
      <v-col v-for="area in areas" v-bind:key="area.name" :cols="grid">
        <pro-d-chart :stats="area"></pro-d-chart>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProDChart from "@/components/assessments/ProDChart"

export default {
  components: { ProDChart },
  props: {
    areas: { type: Array }
  },
  computed: {
    grid() {
      return this.$vuetify.breakpoint.xsOnly ? 12 : 4
    }
  }
}
</script>
